import React, { useCallback, useLayoutEffect, useState } from 'react';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import { Button, SettingsSection, SCROLL_INDICATOR_INSETS, SettingsItemWithCheckBox, withAnimatedNavigationHeader, } from 'design-system';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import useColors from 'hooks/useColors';
import { useCommonInvestStyles } from './styles';
import { RecurringBuyInterval } from '../types';
import { strings } from '../components/OnboardingTitle';
const Interval = withAnimatedNavigationHeader(({ route, navigation: { navigateDeprecated }, navigation, scrollHandler }) => {
    const colors = useColors();
    const { params } = route;
    const commonStyles = useCommonInvestStyles();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary, commonStyles.header]);
    const [recurringBuyInterval, setRecurringBuyInterval] = useState(RecurringBuyInterval.WEEKLY);
    const handleIntervalSelect = useCallback((interval) => () => {
        setRecurringBuyInterval(interval);
    }, []);
    const handlePress = useCallback(() => {
        if (recurringBuyInterval) {
            if (recurringBuyInterval === RecurringBuyInterval.WEEKLY) {
                navigateDeprecated('InvestSelectWeekday', {
                    interval: recurringBuyInterval,
                    ...params,
                });
                return;
            }
            navigateDeprecated('InvestSelectDate', {
                interval: recurringBuyInterval,
                ...params,
            });
        }
    }, [params, recurringBuyInterval]);
    return (<View style={commonStyles.containerNoPadding}>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} keyboardShouldPersistTaps="handled" scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={commonStyles.contentContainer}>
          <ScreenInfoHeader title={strings.Interval.title} subTitle={strings.Interval.subtitle}/>
          <SettingsSection noMarginTop>
            <SettingsItemWithCheckBox title="Weekly" description="Executed every week" onPress={handleIntervalSelect(RecurringBuyInterval.WEEKLY)} selected={recurringBuyInterval === RecurringBuyInterval.WEEKLY}/>
            <SettingsItemWithCheckBox title="Monthly" description="Executed every month" onPress={handleIntervalSelect(RecurringBuyInterval.MONTHLY)} selected={recurringBuyInterval === RecurringBuyInterval.MONTHLY}/>
            <SettingsItemWithCheckBox title="Quarterly" description="Executed every third month" onPress={handleIntervalSelect(RecurringBuyInterval.QUARTERLY)} selected={recurringBuyInterval === RecurringBuyInterval.QUARTERLY}/>
          </SettingsSection>
        </Animated.ScrollView>
        <Button floating title="Continue" brand onPress={handlePress}/>
      </View>);
}, ({ colors }) => ({
    hideTitleOnScroll: true,
    title: strings.Interval.shortTitle,
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default Interval;
